import { FacultyDomain } from '@/module/Faculty/model/FacultyTypes';

import { JobTitle, NamedEntity } from '@feature/utils';

export enum RoleType {
  AUTHOR = 'AUTHOR',
  ADMIN = 'ADMIN',
  UNIVERSITY_ADMIN = 'UNIVERSITY_ADMIN',
  FACULTY_ADMIN = 'FACULTY_ADMIN',
  DEPARTMENT_ADMIN = 'DEPARTMENT_ADMIN',
  DISCIPLINE_ADMIN = 'DISCIPLINE_ADMIN',
  RESEARCH_CENTER_ADMIN = 'RESEARCH_CENTER_ADMIN',
  LAB_ADMIN = 'LAB_ADMIN',
}

export const allRoleTypes = [
  RoleType.AUTHOR,
  RoleType.ADMIN,
  RoleType.UNIVERSITY_ADMIN,
  RoleType.FACULTY_ADMIN,
  RoleType.DEPARTMENT_ADMIN,
  RoleType.DISCIPLINE_ADMIN,
  RoleType.RESEARCH_CENTER_ADMIN,
  RoleType.LAB_ADMIN,
] as const;

export interface CurrentUser {
  id: number;
  lastName: string;
  firstName: string;
  email: string;
  currentRole: RoleType;

  faculty: NamedEntity | null;
  department: NamedEntity | null;
  discipline: NamedEntity | null;

  jobTitle: JobTitle;

  freezeDate: Date | null;

  availableRoles: RoleType[];

  facultyDomain: FacultyDomain | null;
}
